import {
  toggleUserFavorite
} from "./chunk-N7WOQ7B5.mjs";

// src/hooks/wbk/favorites/toggle.ts
import { useMutation, useQueryClient } from "@tanstack/react-query";
var useToggleUserFavorite = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: toggleUserFavorite,
    onSuccess: (data, { slug }) => {
      queryClient.setQueryData(["eventFavorite", { slug }], (data == null ? void 0 : data._id) ? data : null);
    }
  });
};

export {
  useToggleUserFavorite
};
//# sourceMappingURL=chunk-MVD3I5QK.mjs.map